/*
 * @Autor: lh
 * @Date: 2022-05-28 10:33:45
 * @LastEditors: lh
 * @LastEditTime: 2022-06-11 14:11:19
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import getters from './getters.js'
import actions from './actions.js'
import user from './modules/user.js'
import gameData from './modules/gameData.js'


export default new Vuex.Store({
	getters,
	actions,
	modules: {
		user,
		gameData
	}
})





// WEBPACK FOOTER //
// ./src/store/index.js